export const setEmployeeDetailAction = data => {
    return {
        type: 'SET_EMPLOYEE_DETAILS',
        payload: data,
    };
};
